module.exports = __webpack_public_path__ + "img/dots_mbb2.c47b6a90.png";